import { apiClient } from '@/shared/lib/axios';
import { AdminInsurerAttentionUpdateForm } from '@/types/admin-insurer-attention';
import { getApiErrorMessage } from '@/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import useAppToast from '../useAppToast';

const updateInsurerAttention = async (
  siteType: string,
  id: string,
  data: AdminInsurerAttentionUpdateForm
): Promise<void> => {
  await apiClient.put(`/admin/${siteType}/insurer-attentions/${id}`, data);
};

export const useAdminInsurerAttentionUpdate = () => {
  const { site } = useParams<{ site: string }>();
  const siteType = site ?? 'medix';
  const toast = useAppToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: AdminInsurerAttentionUpdateForm }) =>
      updateInsurerAttention(siteType, id, data),
    meta: { suppressNotFoundToast: true },
    onSuccess: (_result, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['admin-insurer-attention-detail', variables.id, siteType],
      });
      queryClient.invalidateQueries({ queryKey: ['admin-insurer-attentions', siteType] });
      toast.success('更新しました。');
    },
    onError: err => {
      toast.error(getApiErrorMessage(err, 'エラーが発生しました。'));
    },
  });
};
